// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__16Vvx","actionsCol":"EnrolledClinics_actionsCol__2KT4v"};